import Tables from './tables.vue';

Tables.install = function (Vue) {
  Vue.component(Tables.name, Tables);
}

export default Tables;


// WEBPACK FOOTER //
// ./src/components/tables/index.js